import React from 'react'
import { Chip, ChipProps } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import PauseCircleIcon from '@mui/icons-material/PauseCircle'

// Project interface with active status
export interface Project {
  'Codigo Centro Costos': number
  'Nombre Proyecto': string
  'Tipo Centro Costos': string
  'Ultima Actualizacion Sistema': string | null
  'Ultima Actualizacion Usuario': string | null
  active: boolean
}

interface ProjectStatusBadgeProps extends Omit<ChipProps, 'color' | 'label'> {
  project: Project
  showIcon?: boolean
  showText?: boolean
}

export const ProjectStatusBadge: React.FC<ProjectStatusBadgeProps> = ({
  project,
  showIcon = true,
  showText = true,
  variant = 'filled',
  size = 'small',
  ...chipProps
}) => {
  const isActive = project.active
  
  const statusConfig = {
    active: {
      color: 'success' as ChipProps['color'],
      icon: <CheckCircleIcon />,
      text: 'Activo',
    },
    inactive: {
      color: 'default' as ChipProps['color'],
      icon: <PauseCircleIcon />,
      text: 'Inactivo',
    },
  }
  
  const config = isActive ? statusConfig.active : statusConfig.inactive
  
  // Apply gray styling for inactive projects as specified in requirements
  const chipStyle = !isActive ? {
    backgroundColor: '#f5f5f5',
    color: '#757575',
    '& .MuiChip-icon': {
      color: '#757575',
    },
    ...chipProps.sx
  } : chipProps.sx
  
  return (
    <Chip
      label={showText ? config.text : undefined}
      color={config.color}
      variant={variant}
      size={size}
      icon={showIcon ? (config.icon as React.ReactElement) : undefined}
      sx={chipStyle}
      {...chipProps}
    />
  )
}

export default ProjectStatusBadge